import { Stack, Tooltip, Typography } from "@mui/material";
import { Progress } from "../Progress";
import { AnalyticItem } from "../AnalyticItem";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { AnalyticCardWrapper } from "../AnalyticCardWrapper";
import { RateIndicator } from "../../../../types/enums";

type Props = {
  expectedSize: number;
  currentSize: number;
  original: number;
  enriched: number;
  children?: React.ReactNode;
  currentTab?: string;
  enriched_indicator?: RateIndicator;
  enriched_change?: number;
  enriched_changed_at?: string;
  original_indicator?: RateIndicator;
  original_change?: number;
  original_changed_at?: string;
};

type TooltipsOption = "Buying Committee" | "Buying Cluster";

const getTooltipText = (key: TooltipsOption, members: number) => {
  const tooltips: Record<TooltipsOption, string> = {
    "Buying Committee": `Possible buying committee size based on company size: up to ${members} members`,
    "Buying Cluster": `Possible buying cluster size based on company size: up to ${members} members`,
  };

  return tooltips[key];
};

export const AccountDiscoveryRate = ({
  expectedSize,
  original,
  enriched,
  children,
  currentTab,
  currentSize,
  enriched_indicator,
  enriched_change,
  enriched_changed_at,
  original_indicator,
  original_change,
  original_changed_at,
}: Props) => {
  return (
    <AnalyticCardWrapper
      title="Members Identified"
      tooltip="Rate of discovered BC members in account data, relative to the expected number
       of BC for this company size."
    >
      {children}
      <Stack gap="20px" flexGrow={1} minWidth="300px" justifyContent="center">
        <Stack gap="54px" direction="row" justifyContent="space-between">
          <Stack>
            <Stack direction="row" alignItems="center">
              <Typography
                variant="h2"
                color="#051123"
                sx={{ fontSize: "32px" }}
              >
                {(original ?? 0) + (enriched ?? 0)}%
              </Typography>
              <Tooltip
                placement="bottom"
                sx={{
                  background: "#596177E5",
                  fontSize: "12px",
                  lineHeight: "16px",
                }}
                arrow
                title={getTooltipText(
                  currentTab as TooltipsOption,
                  expectedSize,
                )}
              >
                <HelpOutlineIcon sx={{ color: "#1C3C6C" }} />
              </Tooltip>
            </Stack>
            <Typography variant="body1" color="#051123">
              {currentSize} members out of {expectedSize} found
            </Typography>
          </Stack>
          <Stack gap="16px" direction="row">
            <AnalyticItem
              title="Your Data"
              percentage={original}
              color="#1B3967"
              indicatorRate={original_indicator}
              indicatorChange={original_change}
              indicatorChangeAt={original_changed_at}
            />
            <AnalyticItem
              title="INFUSE Data Extension"
              percentage={enriched}
              color="#FE8836"
              indicatorRate={enriched_indicator}
              indicatorChange={enriched_change}
              indicatorChangeAt={enriched_changed_at}
            />
          </Stack>
        </Stack>
        <Progress primaryValue={original} secondaryValue={enriched} />
      </Stack>
    </AnalyticCardWrapper>
  );
};
